import { Box, Button, CircularProgress, Grid, Paper, Stack, IconButton, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles';
import GameFact from '../gameFact/GameFact.js'
import { deleteGameFact, updateGameFact } from '../../../actions/gameFact.js'
import RecapNotation from '../import/notation/RecapNotation.js'
import { deleteNotation } from '../../../actions/notation.js'
import RecapArticle from '../import/article/RecapArticle.js'
import { deleteArticle } from '../../../actions/article.js'
import gameFacts from "../gameFact/gamefacts.js"
import RecapSurvey from '../import/sondage/RecapSurvey.js';
import { deleteSurvey } from '../../../actions/sondage.js';
import { deleteQuizz } from '../../../actions/quizz.js';
import RecapQuizz from '../import/quizz/RecapQuizz.js';
import LiveArticle from '../import/article/LiveArticle.js';
import Survey from '../import/sondage/LiveSondage.js';
import Quizz from '../import/quizz/LiveQuizz.js';
import LiveNotation from '../import/notation/LiveNotation.js';
import StatsTableView from '../utils/StatView.js';
import { getPaginedMatchDetail } from '../../../api/index.js';
import { GET_MATCH_DETAILS } from '../../../constants/actionTypes.js';
import { GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_PENALITE, GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_SOCCER_SHOOTOUTPENALTY, GAME_FACT_TRANSFORMATION } from '../gameFact/constants.js';
import { Block } from '@mui/icons-material';

const LiveHistorique = ({match}) => {

    const dispatch = useDispatch()

    const [historique, setHistorique] = useState([])
    const [visibleItems, setVisibleItems] = useState(10);

    const loadMore = async () => {

        try {
          const response = await getPaginedMatchDetail(match.idMatch ?? match.idActu, match.pagination)
          dispatch({ type: GET_MATCH_DETAILS, payload: response.data})
            
        } catch (error) {
          console.error(error);
        }
    }

    const handleShowMore = async () => {

        if(match.hasMore)
            await loadMore()


        const newVisibleItems = visibleItems + 10;
        setVisibleItems(newVisibleItems);
    };

    useEffect(() => {

        const quillEditorContainers = document.querySelectorAll('.ql-container');

        quillEditorContainers.forEach(container => {
            container.style.border = 'none';
        });
    }, [historique])

    useEffect(() => {
        const {gameFacts = [], notations = [], articles = [], surveys = [], quizzs = []} = match

        let sortedHistorique = gameFacts.concat(notations).concat(articles).concat(surveys).concat(quizzs)

        setHistorique(sortedHistorique.sort((a,b) => {

            // Priorité pour les éléments épinglés
            if (a.isPin && !b.isPin) {
                return -1; // a est épinglé, b ne l'est pas, a passe en tête
            }
            if (!a.isPin && b.isPin) {
                return 1; // b est épinglé, a ne l'est pas, b passe en tête
            }

            let bPeriod = b.detail ? b.detail.period : b.period
            let aPeriod = a.detail ? a.detail.period : a.period

            let comparePeriod = bPeriod - aPeriod

            if (comparePeriod !== 0) {
                return comparePeriod;
            }

            let bTimer = b.detail ? parseFloat(b.detail.timer) : parseFloat(b.timer)
            let aTimer = a.detail ? parseFloat(a.detail.timer) : parseFloat(a.timer)
        
            let compareTimer = bTimer - aTimer
        
            if (compareTimer !== 0) {
                return compareTimer;
            }
        
            return new Date(b.creation) - new Date(a.creation);
        }))

    }, [match])

    const [editingInfo, setEditingInfo] = useState(undefined)

    const [editingImport, setEditingImport] = useState(undefined)
    
    const [viewStats, setStatView] = useState(undefined)

    const onChangeText = (gameFact, text) => {
        let newDetail = {...gameFact.detail, text}
        dispatch(updateGameFact(newDetail, gameFact._id))
    }

    const onChangeTitle = (gameFact, title) => {
        let newDetail = {...gameFact.detail, title}
        dispatch(updateGameFact(newDetail, gameFact._id))
    }

    const enterEditMode = (gameFact) => {
        setEditingInfo({...gameFact, detail : {...gameFact.detail, edited : false}})
    }

    const enterEditImportMode = (idElement) => {
        setEditingImport(idElement)
    }

    const leaveEditMode = () => {
        setEditingInfo(undefined)
    }

    const deleteFact = (id) => {
        dispatch(deleteGameFact(id))
    }

    const onDeleteNotation = (id) => {
        dispatch(deleteNotation(id))
    }

    const onDeleteArticle = (id) => {
        dispatch(deleteArticle(id))
    }

    const onDeleteSurvey = (id) => {
        dispatch(deleteSurvey(id))
    }

    const onDeleteQuizz = (id) => {
        dispatch(deleteQuizz(id))
    }

    const enterStatViewMode = (data) => {
        setStatView(data._id);
      };

    const previousViewMode = () => {
        setStatView(undefined);
    }

    const disabledShowMore = useMemo(() => {
        return visibleItems >= historique.length
        && !match.hasMore
    }, [match.hasMore, visibleItems, historique])

    const [pressed, setPressed] = useState(false);

  const handleToggle = () => {
    setPressed(!pressed);
  };

  const getFilteredHistorique = () => {
    if(pressed){
        return historique.filter(h => [
            GAME_FACT_SOCCER_PENALTY,
            GAME_FACT_SOCCER_BUT, 
            GAME_FACT_ESSAI, 
            GAME_FACT_TRANSFORMATION, 
            GAME_FACT_PENALITE, 
            GAME_FACT_DROP].includes(h.type))
    }else{
        return historique
    }
  }

    return (
        match ? 
            editingInfo ? 
            <GameFact gameFact={editingInfo} endProcess={leaveEditMode} match={match}/> 
            :
            <Box>

                {match.type === 'match' && <CustomButton pressed={pressed} onClick={handleToggle}>
                    {pressed ? 'AFFICHER LES BUTS' : 'AFFICHER LES BUTS'}
                </CustomButton>}
                                
                <Stack spacing={2}>{getFilteredHistorique().slice(0, visibleItems).map(g => {

                    try{
                        // Le gamefact n'est pas connu coté front
                        // Fait de jeu
                        if(g.type && g.detail && gameFacts.find(gf => g.type === gf.id)){
                            return <Item key={g._id} onEdit={() => enterEditMode(g)} onDelete={() => deleteFact(g._id)}>{React.createElement(gameFacts.find(gf => gf.id === g.type).recapComponent, {state : g.detail, match, onChangeText : (text) => onChangeText(g, text), onChangeTitle : (title) => onChangeTitle(g, title), inHistory : true})}</Item>
                        // Import
                        }else{
                            if(g.type === 'quizz'){
                                if (editingImport===g._id){
                                    return<Item key={g._id}>
                                        <Quizz
                                            match={match} 
                                            initial={g} 
                                            isEditing={true} 
                                            afterSubmit={() => setEditingImport(undefined)}/>
                                    </Item>
                                    }
                                    if (viewStats===g._id){
                                        return  (match.type === 'match' ? <Item key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></Item>
                                        : <ItemVariant title='quiz' key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></ItemVariant>)
                                    }
                                    
                                    return (match.type === 'match' ? <Item key={g._id} onView={() => enterStatViewMode(g)} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteQuizz(g._id)}><RecapQuizz quizz={g} match={match}/></Item>
                                                : <ItemVariant title='quiz' key={g._id} onView={() => enterStatViewMode(g)} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteQuizz(g._id)}><RecapQuizz quizz={g} match={match}/></ItemVariant> )
                            }
                            else if(g.type === 'survey'){
                                
                                if (editingImport===g._id){
                                    return <Item key={g._id}>
                                        <Survey
                                            match={match} 
                                            initial={g} 
                                            isEditing={true} 
                                            afterSubmit={() => setEditingImport(undefined)}/>
                                    </Item> 
                                }
                                if (viewStats===g._id){
                                    return  (match.type === 'match' ? <Item key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></Item> : <ItemVariant title='sondage' key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></ItemVariant>)
                                }
                                
                                return (match.type === 'match' ?  <Item key={g._id} onView={() => enterStatViewMode(g)} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteSurvey(g._id)}><RecapSurvey survey={g} match={match}/></Item>
                                                                :  <ItemVariant title='sondage' key={g._id} onView={() => enterStatViewMode(g)} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteSurvey(g._id)}><RecapSurvey survey={g} match={match}/></ItemVariant>)
                                
                            }
                            else if(g.type === "article"){
                                return editingImport===g._id ? 
                                    <Item key={g._id}>
                                        <LiveArticle 
                                            match={match} 
                                            initial={g} 
                                            isEditing={true} 
                                            onSubmit={() => setEditingImport(undefined)}/>
                                    </Item> : (match.type === 'match' ? <Item key={g._id} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteArticle(g._id)}><RecapArticle article={g} match={match}/></Item> : <ItemVariant title='article' key={g._id} onEdit={() => enterEditImportMode(g._id)} onDelete={() => onDeleteArticle(g._id)}><RecapArticle article={g} match={match}/></ItemVariant>)
                            // Notations
                            }else{
                                if (editingImport===g._id){
                                    return <Item key={g._id}>
                                    <LiveNotation
                                        match={match} 
                                        initial={g}
                                        isEditing={true}
                                        onSubmit={() => setEditingImport(undefined)}/>
                                </Item>
                                }
                                if (viewStats===g._id){
                                    return (match.type === 'match' ? <Item key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></Item> 
                                    : <ItemVariant title='notation' key={g._id} onPrevious={() => previousViewMode(g)}><StatsTableView data={g}/></ItemVariant>)
                                }
                                return (match.type === 'match' ?  <Item key={g._id}  onEdit={() => enterEditImportMode(g._id)} onView={() => enterStatViewMode(g)} onDelete={() => onDeleteNotation(g._id)}><RecapNotation notation={g} match={match}/></Item>
                                : <ItemVariant title='notation' key={g._id}  onEdit={() => enterEditImportMode(g._id)} onView={() => enterStatViewMode(g)} onDelete={() => onDeleteNotation(g._id)}><RecapNotation notation={g} match={match}/></ItemVariant>)
                            }
                        } 

                    } catch (error) {
                        console.error(`Error rendering item with ID: ${g._id}`, error);
                        return (
                            <Block>
                                <Typography color="error" key={g._id}>
                                    Une erreur est survenue lors du rendu de cet élément.
                                </Typography>
                            </Block>
                        );
                    }
                })
            }</Stack>
                {!disabledShowMore ? (
                    <Button sx={{width : '100%', mt : 2, bgcolor : "multiplex.darkblue"}} onClick={handleShowMore} variant="contained">
                    Voir plus
                    </Button>
                ) : (
                    <Button sx={{width : '100%', mt : 2}} variant="contained" disabled>
                    Début du direct
                    </Button>
                )}
            </Box>:
        <CircularProgress/>
    )

}

const ItemStyled = styled(Paper)(({ theme, selected }) => ({
    backgroundColor: selected ? '#9eecff' : '#fff',
    '&:hover': {
        backgroundColor : '#ededed'
     },
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const Item = ({value, id, children, onEdit, onDelete, onView, onPrevious, key}) => {

    return (
        <ItemStyled key={id ?? key} id={id}> 
            <Grid container alignItems={"center"}>
                <Grid item xs={12} sm={(!onEdit && !onDelete) ? 12 : 8}>
                    {children} 
                    {onPrevious && <Button onClick={onPrevious}>Retour</Button>}
                </Grid>
                {!onPrevious && <Grid item xs={12} sm={4}>
                    {onView && <Button onClick={onView}>Voir</Button>}
                    {onEdit && <Button disabled={!onEdit} onClick={onEdit}>Modifier</Button>}
                    {onDelete && <Button onClick={onDelete}>Supprimer</Button>}
                </Grid>}
            </Grid>
        </ItemStyled>
    ) 
}

const ItemVariant = ({value, id, children, onEdit, onDelete, onView, onPrevious, key, title}) => {

    return (
        <ItemStyled key={id ?? key} id={id}> 
        <Box sx={{display: 'flex', justifyContent: 'flex-end'}} >
            <Typography sx={{borderRadius: '5px',
                            backgroundColor: '#75757594',
                            color: 'white',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                            minWidth:'65px'
                            }}>{title}</Typography>
        </Box>
        <Box sx={{ padding: 2, border: '1px solid #e0e0e0', borderRadius: 1, marginBottom: 2 }} key={id ?? key} id={id}>
            
            {/* Actions */}
            <Grid container alignItems="center" justifyContent="space-between" sx={{ marginBottom: 2 }}>
                <Grid item>
                    {onEdit && (
                        <IconButton onClick={onEdit}>
                            <EditIcon /> <Typography sx={{ marginLeft: 1 }}>Modifier</Typography>
                        </IconButton>
                    )}
                    {onDelete && (
                        <IconButton onClick={onDelete}>
                            <DeleteIcon /> <Typography sx={{ marginLeft: 1 }}>Supprimer</Typography>
                        </IconButton>
                    )}
                    {onView && (
                        <IconButton onClick={onView}>
                            <VisibilityIcon /> <Typography sx={{ marginLeft: 1 }}>Voir détail</Typography>
                        </IconButton>
                    )}
                </Grid>
                {onPrevious && (
                    <Grid item>
                        <Button startIcon={<ArrowBackIcon />} onClick={onPrevious}>
                            Retour
                        </Button>
                    </Grid>
                )}
            </Grid>

            {/* Contenu */}
            <Grid container>
                <Grid item xs={12}>
                    {children}
                </Grid>
            </Grid>
        </Box>
        </ItemStyled>
    );
}

const CustomButton = styled(Button)(({ pressed }) => ({
    margin : '10px',
    backgroundColor: pressed ? 'green' : 'gray',
    color: 'white',
    boxShadow: pressed ? 'inset 2px 2px 5px rgba(0,0,0,0.3)' : '2px 2px 5px rgba(0,0,0,0.3)',
    transform: pressed ? 'translateY(2px)' : 'translateY(0)',
    '&:hover': {
      backgroundColor: pressed ? 'darkgreen' : 'darkgray',
      boxShadow: pressed ? 'inset 2px 2px 5px rgba(0,0,0,0.3)' : '2px 2px 5px rgba(0,0,0,0.3)',
    },
  }));

export default LiveHistorique